import { useTranslation } from "react-i18next";
import { SIMPLVmTable } from "../../SimplVmTable";

export const SIMPLVmPolicies = () => {
  const { t } = useTranslation();
  return (  
  <SIMPLVmTable
    type="policies"
    addButtonLabel={t("AddPolicy")}
    addModalTitle={t("VmPolicies")}
    LoadingTitle={t("LoadingPolicies")}
    contentLabel={t("Rules")}
    contentMessage={t("Rules are required")}
    placeholder={t("Rules")}
    messageRequired={t("MessagesRulesRequired")}
  />
  );
};